import React from 'react'
import {Button, OverlayTrigger, Spinner, Tooltip} from 'react-bootstrap'
import {LandingPageShortCode} from '../../../../../services/cellcast.v2.types'
import './LandingPageMobileCard.scss'

interface LandingPageMobileCardProps {
  item: LandingPageShortCode
  onExport: (code?: string) => void
  isLoadingExport: boolean
}

export const LandingPageMobileCard: React.FC<LandingPageMobileCardProps> = ({
  item,
  onExport,
  isLoadingExport,
}) => {
  return (
    <div className='landing-page-mobile-card'>
      {/* Header */}
      <div className='card-header-section'>
        <div className='d-flex align-items-center gap-3 flex-grow-1'>
          <div className='link-info-section'>
            <h5 className='link-title'>{item.fullUrl || '--'}</h5>
          </div>
        </div>
        <OverlayTrigger
          placement='top'
          overlay={
            <Tooltip id={`tooltip-export-${item.shortCode}`}>
              <span>Export</span>
            </Tooltip>
          }
        >
          <Button
            variant='light'
            className='btn btn-icon btn-sm'
            onClick={() => onExport(item?.shortCode)}
            disabled={isLoadingExport}
          >
            {isLoadingExport ? <Spinner size='sm' /> : <i className='bi bi-download'></i>}
          </Button>
        </OverlayTrigger>
      </div>

      {/* Details */}
      <div className='card-details-grid'>
        {/* Landing Page */}
        {item.landingPageData?.campaignName && (
          <div className='detail-item'>
            <span className='detail-label'>
              <i className='fas fa-globe me-1'></i>
              Landing Page
            </span>
            <span className='detail-value'>{item.landingPageData.campaignName}</span>
          </div>
        )}

        {/* Number */}
        {item.number && (
          <div className='detail-item'>
            <span className='detail-label'>
              <i className='fas fa-phone me-1'></i>
              Number
            </span>
            <span className='detail-value'>{item.number}</span>
          </div>
        )}

        {/* Bulk */}
        {item.bulkData?.name && (
          <div className='detail-item'>
            <span className='detail-label'>
              <i className='fas fa-layer-group me-1'></i>
              Bulk
            </span>
            <span className='detail-value'>{item.bulkData.name}</span>
          </div>
        )}

        {/* Click */}
        <div className='detail-item'>
          <span className='detail-label'>
            <i className='fas fa-mouse-pointer me-1'></i>
            Click
          </span>
          <span className='detail-value'>{item.click || 0}</span>
        </div>
      </div>
    </div>
  )
}

